import axios from "../libs/api.request.js";

export const sendSubmit = params => {
    return axios.request({
      url: "admin/news/sendEmail",
      method: "post",
      data: params
    });
  };


// WEBPACK FOOTER //
// ./src/api/contect.js